export default __webpack_public_path__ + "static/media/logo.ffdedfb0.png";